import React from 'react';
import ResumeRating from './_Rating';
import './_resume.scss';

const skills = {
  'C#': 4.5,
  JavaScript: 4,
  PHP: 4,
  Python: 4,
  'ASP.NET MVC': 4.5,
  Django: 4,
  Laravel: 4,
  'Node.js / Express': 3,
  Yii: 3,
  HTML: 4.5,
  CSS: 4,
  Sass: 3,
  HTTP: 4,
  AJAX: 3.5,
  'React/Redux': 3.5,
  AWS: 3,
  Heroku: 4,
  Nginx: 3,
  IIS: 3,
  PostgreSQL: 3,
  'SQL Server': 3,
};

const ResumeRatings = () => (
  <section>
    <h1 className="resume--aside-title">Technical Highlights</h1>
    <div>{Object.keys(skills).map(key => <ResumeRating skill={key} rating={skills[key]} />)}</div>
  </section>
);

export default ResumeRatings;



// WEBPACK FOOTER //
// ./src/pages/resume/_Ratings.js